module.exports = __webpack_public_path__ + "media/nf_tagging.1d7b82cb.mp4";